import { useEffect } from "react";

export const useArrayElementsInViewport = ({ arrayRefs, callback }) => {
  useEffect(() => {
    const observer = new IntersectionObserver(callback, { threshold: 1 });
    arrayRefs.current.forEach((ref) => {
      if (ref) {
        observer.observe(ref);
      }
    });

    return () => {
      if (arrayRefs.current) {
        arrayRefs.current.forEach((ref) => {
          if (ref) {
            observer.unobserve(ref);
          }
        });
      }
    };
  }, [callback, arrayRefs]);
};
